import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import * as ih from 'helpers/ingredientHelpers';
import chevLeft from 'icons/chevron-left-24.png';

export default function IngredientInfo(props) {
  const navigate = useNavigate();
  const params = useParams();
  const iId = Number(params.id);
  console.log('IngredientInfo', iId);

  const ing = ih.getIngredientByIngredientId(iId);
  const mInfo = ih.getMedsContainingIngredient(iId);
  //console.log('IngredientInfo data', ing, mInfo);
  const dn = ih.formatDisplayName(ing);
  const c = ih.ingredientConsumption(mInfo, ing);
  
  return (
    <div className='mcard'>
      <div className='mcard-screen flex justify-between h-100'>
        <div className='hover:cursor-pointer' onClick={()=>navigate(-1)}>
          <img src={chevLeft} alt='' />
        </div>
        <div className='w-full pl-4'>
          <div className='text-base '>Meds Containing Ingredient</div>
          <div>{dn}</div>
        </div>
      </div>
      <div id='scroll_area' className='lcard'>
        { mInfo.map((m,ix) => {
            const dose = ih.formatDosage(m);
            return (
                <div key={ix} className='mcard border-2 border-gray-200 mt-2 mb-1'>
                    <div className='mcard-header flex justify-between'>
                        <div>{m.name}</div>
                        <div>{dose}</div>
                    </div>
                </div>
                )
            })
        }
      </div>
      <div className='flex flex-col w-full justify-center items-center mb-2'>
            <table className='w-10/12 mt-4 text-base small:text-lg font-semibold'>
              <thead></thead>
              <tbody>
                <tr className='zebra'>
                  <td>Taken today:</td>
                  <td className='w-24'>{c.today} {c.units}</td>
                </tr>
                <tr className='zebra'>
                  <td>Taken yesterday:</td>
                  <td>{c.yesterday} {c.units}</td>
                </tr>
                <tr className='zebra'>
                  <td>Taken past 7 days:</td>
                  <td>{c.sevenDays} {c.units}</td>
                </tr>
                <tr className='zebra'>
                  <td>Taken past 30 days:</td>
                  <td>{c.thirtyDays} {c.units}</td>
                </tr>
              </tbody>
            </table>
          </div>
    </div>
  )
}
